export const EditorHeader = {
    isEditing : false,
    submit : ()=>{},
    cancel : ()=>{}
}
